import React from 'react'
import PropTypes from 'prop-types'
// import { Platform, Text, StyleSheet, Dimensions } from 'react-native'

import { Colors, Fonts } from '../../global'

// const isIos = () => !!(Platform.OS === 'ios')
// const { width, height } = Dimensions.get('window')

const getFontFamily = (font,weight) => {
  switch (font) {
    case 'inter':
      if(weight=="bold") return 'Inter-Black'
      if(weight=="light") return 'Inter-ExtraLight'
      if(weight=="semibold") return 'Inter-SemiBold'
      if(weight=="medium") return 'Inter-Medium'
      return 'Inter-Regular'
    case 'thin':
      if(weight=="bold") return 'OpenSansCondensed-Bold'
      return 'OpenSansCondensed-Light'
    default:
      return 'Inter-Regular'
  }
  
}
const styles = {
  h1: {
    ...Fonts.h1,
  },
  h2: {
    ...Fonts.h2,
  },
  h3: {
    ...Fonts.h3,
  },
  h4: {
    ...Fonts.h4,
  },
  h5: {
    ...Fonts.h5,
  },
  h6: {
    ...Fonts.h6,
  },
  lg: {
    ...Fonts.lg,
  },
  md: {
    ...Fonts.md,
  },
  sm: {
    ...Fonts.sm,
  },
  xs: {
    ...Fonts.xs,
  },
  headline: {
    ...Fonts.headline,
  },
  body: {
    ...Fonts.body,
  },
  subtitle: {
    ...Fonts.subtitle,
  },
  caption: {
    ...Fonts.caption,
  },
  footnote: {
    ...Fonts.footnote,
  },
  semiBold: {
    fontWeight: '600',
  },
  bold: {
    fontWeight: '700',
  },
  medium: {
    fontWeight: '400',
  },
  light: {
    fontWeight: '300',
  },
  xlight: {
    fontWeight: '200',
  },
  xxxlarge: {
    ...Fonts.xxxlarge,//width < 414 ? (width < 360 ? 32 : 36) : 40,
  },
  xxlarge: {
    ...Fonts.xxlarge,//width < 414 ? (width < 360 ? 32 : 36) : 40,
  },
  xlarge: {
    ...Fonts.xlarge,//width < 414 ? (width < 360 ? 22 : 26) : 30,
  },
  large: {
    ...Fonts.large,//width < 414 ? (width < 360 ? 18 : 22) : 26,
  },
  medium: {
    ...Fonts.medium,//width < 414 ? (width < 360 ? 16 : 18) : 20,
  },
  small: {
    ...Fonts.small,//width < 414 ? (width < 360 ? 12 : 14) : 16,
  },
  xsmall: {
    ...Fonts.xsmall,//width < 414 ? (width < 360 ? 10 : 12) : 14,
  },
  hint: {
    ...Fonts.hint,//width < 414 ? (width < 360 ? 8 : 10) : 12,
  },
  tiny: {
    ...Fonts.tiny,//width < 414 ? (width < 360 ? 8 : 10) : 12,
  },
}

const TextComponent = ({ children, as = TextComponent.defaultProps.as, weight, color, style,font = 'inter', ...rest }) => {
  if(Array.isArray(style)) style = Object.assign({}, ...style)
  return (
    <small {...rest} style={{ whiteSpace:'break-spaces',color: Colors[color], fontFamily:getFontFamily(font,weight),...styles[weight], ...styles[as], ...style}}>
      {children}
    </small>
  )
}

TextComponent.defaultProps = {
  as: 'medium',
  style: null,
  color: 'primary',
  weight: 'medium',
  font: 'inter',
}

TextComponent.propTypes = {
  as: PropTypes.oneOf([
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'lg',
    'md',
    'sm',
    'xs',
    'headline',
    'body',
    'subtitle',
    'caption',
    'footnote',
    'xsmall',
    'small',
    'medium',
    'large',
    'xlarge',
    'xxlarge',
    'xxxlarge',
    'hint',
    'tiny'
  ]),
  color: PropTypes.oneOf(['textPrimary', 'textSecondary', 'textDisable', 'error', 'positive', 'hint', 'link', 'black','white','greenDark','orangeDark']),
  weight: PropTypes.oneOf(['xlight', 'light', 'medium', 'semiBold','bold','regular']),
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  children: PropTypes.any.isRequired,
}

export default TextComponent
